import { FAQsPropertyItem } from '@mygpt/app/faqs-property/services/list';
import { APIPropertyFunction } from '@mygpt/app/functions/services/list';
import { Http } from '@mygpt/app/http';

export interface UpdateApiParamsFunction extends APIPropertyFunction {
  // 数据集 ID
  datasetId: string;
  id: string;
}

/**
 * 更新问答
 * @param params
 * @returns
 */
export const updateApiServiceFunction = (params: UpdateApiParamsFunction) => {
  const { datasetId, id, ...rest } = params;
  const { put } = Http.use();
  rest.header_authorization = rest.header_authorization || '{}';
  return put<FAQsPropertyItem>(`/datasets/${datasetId}/functions/${id}`, rest);
};
